import { create } from "zustand";

// Стор состояния SSE-стрима уведомлений.
//
// Владелец записи — ровно один подписчик: глобальный
// `NotificationStreamSubscriber` из `ProtectedRoute`, он передаёт
// `trackStatus: true` явно. Page-level подписки (например
// `TaskDetailPage`) вызывают `useNotificationStream` без этой опции —
// default `false` — и в этот стор не пишут; иначе их размонтирование
// при уходе со страницы стирало бы индикатор, принадлежащий
// глобальному стриму.
//
// Без `persist`: это runtime-состояние текущей вкладки, а не
// пользовательская настройка. Сохранённый в localStorage
// `"unavailable"` пережил бы перезагрузку страницы и врал бы про
// состояние ещё не запущенного стрима.

export type NotificationStreamStatus =
  | "idle" // подписка не запущена: нет identity или компонент размонтирован
  | "live" // соединение установлено, события идут
  | "reconnecting" // временный сбой, переподключаемся с back-off
  | "unavailable"; // терминальный отказ, повторять бессмысленно

export interface NotificationStreamState {
  readonly status: NotificationStreamStatus;
  setStatus(status: NotificationStreamStatus): void;
}

export const useNotificationStreamStore = create<NotificationStreamState>()(
  (set) => ({
    status: "idle",
    setStatus: (status) => {
      set({ status });
    },
  }),
);
